import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
    Checkbox, Flex, Image, Label, LabeledControl, Text, TextButton, Trigger,
} from '@zillow/constellation';
import { Col, Row } from '@zillow/zrs-comet';

import WizardBodyTemplate from 'app/shared/components/WizardBodyTemplate';
import WizardActionFooter from 'app/shared/components/WizardActionFooter';
import ToolExplanationModal from 'app/shared/components/Modal/ToolExplanationModal';


const propTypes = {
    onGoToPrevStep: PropTypes.func.isRequired,
    onGoToNextStep: PropTypes.func.isRequired,
};
const defaultProps = {};

const OnlineTools = ({ onGoToPrevStep, onGoToNextStep }) => {
    const [isConfirmed, setIsConfirmed] = useState(false);

    const toolExplanationModal = (props, close) => (
        <ToolExplanationModal {...props} close={close} />
    );

    return (
        <WizardBodyTemplate
            title="Rent guarantee's online tools"
            subtitle="Get seamless property management with Rent Guarantee’s convenient application, lease, and payment
            tools for finding the right tenant and managing your rental."
        >
            <Trigger triggered={toolExplanationModal}>
                <TextButton marginBottom="sm">Why Rent Guarantee requires using these tools </TextButton>
            </Trigger>
            <Row marginBottom="lg">
                <Col xs={4}>
                    <Image
                        alt="Applications"
                        src="http://filecache.mediaroom.com/mr5mr_zillow/204622/Zillow_Wordmark_Blue_RGB.jpg"
                        marginBottom="md"
                    />
                    <Text fontType="bodyHeading">Applications. </Text>
                    <Text>
                        Screening tenants has never been easier, thanks to automatic background and credit checks.
                        We pull the data to quickly confirm applicants are eligible for Rent Guarantee.
                    </Text>
                </Col>
                <Col xs={4}>
                    <Image
                        alt="Lesases"
                        src="http://filecache.mediaroom.com/mr5mr_zillow/204622/Zillow_Wordmark_Blue_RGB.jpg"
                        marginBottom="md"
                    />
                    <Text fontType="bodyHeading">Leases. </Text>
                    <Text>
                        Upload your lease to Zillow, or create a new one using our tool. With your lease terms and
                        tenant info on hand, we can receive and process your claim quickly.
                    </Text>
                </Col>
                <Col xs={4}>
                    <Image
                        alt="Payments"
                        src="http://filecache.mediaroom.com/mr5mr_zillow/204622/Zillow_Wordmark_Blue_RGB.jpg"
                        marginBottom="md"
                    />
                    <Text fontType="bodyHeading">Payments. </Text>
                    <Text>
                        With Zillow online payments, your tenant can pay rent directly into your bank account, and
                        we’ll have a record of any missed payments to help us process your claim fast.
                    </Text>
                </Col>
            </Row>
            <Flex display="flex" justifyContent="center" marginBottom="lg">
                <LabeledControl
                    label={<Label>I understand that these Zillow tools are required for Rent Guarantee</Label>}
                    control={<Checkbox checked={isConfirmed} onClick={() => setIsConfirmed(!isConfirmed)} />}
                />
            </Flex>
            <WizardActionFooter
                onBackClick={onGoToPrevStep}
                onNextClick={onGoToNextStep}
                isNextDisabled={!isConfirmed}
            />
        </WizardBodyTemplate>
    );
};

OnlineTools.propTypes = propTypes;
OnlineTools.defaultProps = defaultProps;

export default OnlineTools;
